import type { EmbedMessage, EmbedMessageType, EmbedEventType } from '../_types/embed'

/**
 * Send a message to the parent window
 */
export function sendMessageToParent(type: EmbedMessageType, payload?: any): void {
  if (typeof window === 'undefined' || window.parent === window) {
    return // Not in iframe
  }

  const message: EmbedMessage = { type, payload }

  // Send to parent - use * as target origin since we're inside the iframe
  window.parent.postMessage(message, '*')
}

/**
 * Send ready message to parent
 */
export function sendReady(): void {
  sendMessageToParent('GIVEEASY_READY')
}

/**
 * Request iframe height resize
 */
export function sendResize(height: number): void {
  sendMessageToParent('GIVEEASY_RESIZE', { height })
}

/**
 * Request scroll to top of iframe
 */
export function sendScrollToTop(): void {
  sendMessageToParent('GIVEEASY_SCROLL_TO_TOP')
}

/**
 * Broadcast an event to parent
 */
export function sendEvent(event: EmbedEventType, data?: any): void {
  sendMessageToParent('GIVEEASY_EVENT', { event, data })
}

/**
 * Request redirect on parent page
 */
export function sendRedirect(url: string): void {
  sendMessageToParent('GIVEEASY_REDIRECT', { url })
}

/**
 * Check if we're in an iframe
 */
export function isInIframe(): boolean {
  if (typeof window === 'undefined') return false
  return window.self !== window.top
}

/**
 * Get parent origin from URL parameter
 */
export function getParentOrigin(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  return params.get('parentOrigin')
}
